// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#picture-list[data-v-7300fe74]{max-width:1280px;margin-left:auto;margin-right:auto}#picture-list .box .tab[data-v-7300fe74]{margin-top:24px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
